import AdminSection, { humanize } from "./AdminSection";

const REQUEST_TYPES = [
  { value: "workplace_chaplaincy", label: "Workplace Chaplaincy" },
  { value: "healthcare_hospice", label: "Healthcare & Hospice" },
  { value: "senior_living", label: "Senior Living / Board & Care" },
  { value: "training_workshop", label: "Training or Workshop" },
  { value: "organizational_consultation", label: "Organizational Consultation" },
  { value: "employee_support", label: "Employee Support" },
  { value: "other", label: "Other" },
];

const config = {
  title: "Organizational Bookings",
  path: "bookings",
  statuses: ["new", "contacted", "confirmed", "completed", "reschedule_requested", "cancelled", "closed"],
  extraFilters: [{ key: "request_type", label: "types", options: REQUEST_TYPES }],
  columns: [
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
    { key: "name", label: "Name", render: (r) => `${r.first_name} ${r.last_name}` },
    { key: "organization", label: "Organization" },
    { key: "request_type", label: "Type" },
    { key: "status", label: "Status" },
  ],
  detailFields: [
    { key: "email", label: "Email" }, { key: "phone", label: "Phone" }, { key: "organization", label: "Organization" }, { key: "role", label: "Role" },
    { key: "request_type", label: "Request type", render: (r) => humanize(r.request_type) },
    { key: "preferred_contact", label: "Preferred contact", render: (r) => humanize(r.preferred_contact) },
    { key: "preferred_date", label: "Preferred date" },
    { key: "preferred_time", label: "Preferred time", render: (r) => humanize(r.preferred_time) },
    { key: "message", label: "Message" },
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
  ],
};

export default function AdminBookings() { return <AdminSection config={config} />; }
